import { Component } from '@angular/core';

@Component({
  selector: 'app-hygine-landing',
  templateUrl: './hygine-landing.component.html',
  styleUrls: ['./hygine-landing.component.scss']
})
export class HygineLandingComponent {

}
